"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _components = require("@/components");
var _log = require("@/api/data/log");
var _user = require("@/api/data/user");
var _apply = require("@/api/data/apply");
var _date = require("@/utils/date.js");
var _router = _interopRequireDefault(require("@/router"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OperateLog',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    return {
      pagination: {
        total: 0,
        limit: 20,
        page: 1
      },
      searchForm: {
        creator_id: undefined,
        apply: null,
        created_at: null,
        operation_type: null,
        ip: null
      },
      operatorList: [],
      appList: [],
      operationList: {},
      listData: [],
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  activated: function activated() {
    this.init();
  },
  created: function created() {
    _date.initWeekDateRange.call(this);
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      this.fetchData();
      var params = {
        limit: 1000,
        page: 1
      };
      (0, _user.getUserList)(params).then(function (res) {
        _this.operatorList = res.data.list.map(function (item) {
          return {
            label: "".concat(item.real_name, "-").concat(item.name),
            value: item.id
          };
        });
      });
      (0, _apply.getApplyList)(params).then(function (res) {
        _this.appList = res.data.list;
      });
      (0, _log.getOperationList)().then(function (res) {
        _this.operationList = res.data.list;
      });
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(page) {
        var _this2 = this;
        var params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.$route.meta.authList.includes('Log/get')) {
                _context.next = 4;
                break;
              }
              _router.default.go(-1);
              this.$message.error('没有查看权限');
              return _context.abrupt("return");
            case 4:
              if (page) this.pagination.page = page;
              this.searchForm.created_at ? this.searchForm.date = this.searchForm.created_at.join(' - ') : '';
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), this.pagination);
              _context.next = 9;
              return (0, _log.getLogList)(params);
            case 9:
              res = _context.sent;
              this.listData = res.data.list;
              this.listData.forEach(function (item) {
                item.address = item.province + (item.city && '-' + item.city);
                item.operation_type_name = _this2.operationList[item.operation_type] || '未知';
              });
              this.pagination.total = res.data.total;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    /* 处理每页展示的数量改变事件 */handlePageSizeChange: function handlePageSizeChange(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
      // 重新加载表格数据
      this.fetchData();
    },
    /* 处理切页 */handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      // 重新加载表格数据
      this.fetchData();
    }
  }
};
exports.default = _default;